import { ValueObject } from '@/engine/core/valueObject';

export class CaseContext extends ValueObject<{ caseId: string; packageId: string }> {
  public get caseId(): string {
    return this.props.caseId;
  }

  public get packageId(): string {
    return this.props.packageId;
  }
}
